import moment from 'moment'

class DateUtil {
  isSaturday(date: Date): boolean {
    return date.getDay() === 6
  }

  isSunday(date: Date): boolean {
    return date.getDay() === 0
  }

  isWeekend(date: Date): boolean {
    return this.isSaturday(date) || this.isSunday(date)
  }

  formatDateToString(date: Date): string {
    if (date === undefined) return null!
    let cloneDate = new Date(date)
    const offset = cloneDate.getTimezoneOffset()
    cloneDate.setTime(cloneDate.getTime() + -1 * offset * 60 * 1000)
    return cloneDate.toISOString().split('T')[0]
  }

  formatStringToDate(date: string): string {
    return moment(date).format('YYYY-MM-DD')
  }

  formatStringToDateTime(date: string): string {
    return moment(date).format('YYYY-MM-DDTHH:mm:ss')
  }

  getNearestWorkDay(): Date {
    let date = new Date()
    if (this.isSaturday(date)) date.setDate(date.getDate() + 2)
    if (this.isSunday(date)) date.setDate(date.getDate() + 1)
    return date
  }

  // 15.05.2021
  dateFormat = (date: Date) => {
    if (date === null || date === undefined) return ''
    return moment(date).format('DD.MM.YYYY')
  }

  formatDayofWeek = (date: Date) => {
    if (date === null || date === undefined) return ''
    let res = moment(date)
    return res.format('dddd')
  }

  getPastDate(count: number) {
    return moment().subtract(count, 'd').toDate()
  }

  getFutureDate(count: number) {
    return moment().add(count, 'd').toDate()
  }

  futureMonth(): Date {
    return moment().add(1, 'M').toDate()
  }

  previousMonth(): Date {
    return moment().subtract(1, 'M').toDate()
  }

  getCurrentWeek() {
    const date = new Date()
    const start = moment(date).startOf('isoWeek').toDate()
    const end = moment(date).endOf('isoWeek').toDate()
    return { start, end }
  }

  defaultWeekdays() {
    return Array.apply(null, Array(7)).map(function (_, i) {
      return moment(i, 'e')
        .startOf('week')
        .isoWeekday(i + 1)
        .format('dddd')
    })
  }

  getWeekDayRange(startDate: Date, endDate: Date) {
    let fromDate = moment(startDate)
    let toDate = moment(endDate)
    let diff = toDate.diff(fromDate, 'days')
    let range = []
    for (let i = 0; i <= diff; i++) {
      range.push(moment(startDate).add(i, 'days').format('Do MMMM dddd'))
    }
    return range
  }

  getWeekStartEndFromDate = (date?: Date) => {
    const year = new Date().getFullYear().toString()
    const weeknumber = !!date ? moment(date).week() : moment().week()
    const start = moment(year).week(weeknumber).startOf('isoWeek').toDate()
    const end = moment(year).week(weeknumber).endOf('isoWeek').toDate()

    return { start, end }
  }

  getStartOfDay = (date: Date): Date => {
    return moment(date).startOf('day').toDate()
  }

  getEndOfDay = (date: Date): Date => {
    const end = moment(date).endOf('day').toDate()
    return end
  }

  getDayFromDate(date: Date | string): string {
    if (!moment(date).isValid()) return ''
    return moment(date).format('dddd')
  }

  dateEquals(date1: Date, date2: Date): boolean {
    return this.formatDateToString(date1) === this.formatDateToString(date2)
  }

  IsPastReservations(startDate: Date): boolean {
    let today = new Date()
    today.setHours(0, 0, 0, 0)
    return today.getTime() > startDate.getTime()
  }

  IsAfterDate(date1: Date, date2: Date): boolean {
    return moment(date1).isSameOrAfter(moment(date2), 'date')
  }
}

export default new DateUtil()
